function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireb88e"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireb88e"] = parcelRequire;
}
parcelRequire.register("9wJdH", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $6efa2df7948f6795$export$6503ec6e8aabbaf; }, function (v) { return $6efa2df7948f6795$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $6efa2df7948f6795$export$f7ad0328861e2f03; }, function (v) { return $6efa2df7948f6795$export$f7ad0328861e2f03 = v; });
var $6efa2df7948f6795$export$6503ec6e8aabbaf;
var $6efa2df7948f6795$export$f7ad0328861e2f03;
"use strict";
var $6efa2df7948f6795$var$mapping = {};
function $6efa2df7948f6795$var$register(pairs) {
    var keys = Object.keys(pairs);
    for(var i = 0; i < keys.length; i++)$6efa2df7948f6795$var$mapping[keys[i]] = pairs[keys[i]];
}
function $6efa2df7948f6795$var$resolve(id) {
    var resolved = $6efa2df7948f6795$var$mapping[id];
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return resolved;
}
$6efa2df7948f6795$export$6503ec6e8aabbaf = $6efa2df7948f6795$var$register;
$6efa2df7948f6795$export$f7ad0328861e2f03 = $6efa2df7948f6795$var$resolve;

});

var $d79987a08a40f6c3$exports = {};

(parcelRequire("9wJdH")).register(JSON.parse('{"3qZSL":"index.fe51495f.js","fG59c":"Grocery.9a368f34.js","4iFYt":"index.8c2c7016.css"}'));


//# sourceMappingURL=index.92903e50.js.map
